.container {
  composes: -expand from "./util.module.css";
}

.hidden {
  composes: container;
  display: none;
}
